import "jquery";

import '@popperjs/core'

//import "bootstrap/dist/js/bootstrap.js";
import "select2";
import "dompurify";

import "jquery-ajax-unobtrusive";
import 'jquery-ui-bundle';

import { App } from "./App";
import { StringHelper } from "./Helpers/StringHelper";
import { Select2Helper } from "./Helpers/Select2Helper";

$("document").ready(() => {

    //$(document).ajaxComplete(function (event, xhr, settings) {
    //    $('button').blur();
    //});

    $(document).ajaxComplete(function( event, xhr, settings ) {
        $('[data-bs-toggle="tooltip"]').tooltip({ container: 'body', trigger: 'hover' });
        StringHelper.bindNumberStringInputs();

        $('select.select2').each((index, element) => {
            var selectElement = $(element);
            Select2Helper.BindSelect2Input(selectElement);
        });

    });
    new App();
});